import { openBlock as t, createElementBlock as n, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ e("path", {
  fill: "#D80027",
  d: "m13.043 18.26 1.74 21.051c1.663.448 3.412.689 5.217.689 11.046 0 20-8.954 20-20l-26.957-1.74Z"
}, null, -1), c = /* @__PURE__ */ e("path", {
  fill: "#FFDA44",
  d: "M13.043 20 14.783.689A20.022 20.022 0 0 1 20 0c11.046 0 20 8.954 20 20H13.043Z"
}, null, -1), s = /* @__PURE__ */ e("path", {
  fill: "#6DA544",
  d: "M0 20c0 9.24 6.267 17.016 14.783 19.311V.689C6.267 2.984 0 10.759 0 20Z"
}, null, -1), i = [
  l,
  c,
  s
];
function d(r, _) {
  return t(), n("svg", o, [...i]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
